export const REFERRAL_SOURCE_OPTIONS = [
  {
    label: "Social Media (Instagram, Facebook, etc.)",
    value: "social",
  },
  { label: "VIN or Reddit", value: "vin_reddit" },
  { label: "From a Friend", value: "word_of_mouth" },
  { label: "From your Sales Team", value: "sales_team" },
  { label: "Google Search", value: "google_search" },
  { label: "Webinar", value: "webinar" },
  { label: "Conference", value: "conference" },
  { label: "Podcast", value: "podcast" },
  { label: "Advertisement", value: "advertisement" },
  { label: "Other", value: "other" },
];
